
import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Brain, Twitter, Coins } from 'lucide-react';

interface InitiationPathProps {
  onComplete: (data: { chosenPath: string }) => void;
}

const InitiationPath = ({ onComplete }: InitiationPathProps) => {
  const [selectedPath, setSelectedPath] = useState<'cipher' | 'twitter' | 'liquidity' | null>(null);

  const paths = [
    {
      id: 'cipher' as const,
      title: 'The Cipher',
      description: 'Take the knowledge test to prove your worth',
      icon: Brain,
      rank: 'Initiated Bro',
      points: 50
    },
    {
      id: 'twitter' as const,
      title: 'Social Engagement',
      description: 'Complete social media challenges',
      icon: Twitter,
      rank: 'Social Bro',
      points: 35
    },
    {
      id: 'liquidity' as const,
      title: 'Liquidity Provider',
      description: 'Provide liquidity to earn your rank',
      icon: Coins,
      rank: 'Shadow Bro',
      points: 75
    }
  ];

  const handlePathSelect = (pathId: 'cipher' | 'twitter' | 'liquidity') => {
    console.log('Path selected:', pathId);
    onComplete({
      chosenPath: pathId
    });
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-xl font-bold text-tan mb-2">Choose Your Path</h3>
        <p className="text-tan-dark">
          Select how you want to earn your BroCode and join the brotherhood
        </p>
      </div>

      <div className="space-y-3">
        {paths.map((path) => {
          const Icon = path.icon;
          return (
            <Card 
              key={path.id}
              className={`bg-navy-dark border-tan-dark cursor-pointer transition-all hover:border-tan ${
                selectedPath === path.id ? 'border-tan bg-navy' : ''
              }`}
              onClick={() => setSelectedPath(path.id)}
            >
              <CardContent className="p-4">
                <div className="flex items-center space-x-4">
                  <Icon className="text-tan flex-shrink-0" size={24} />
                  <div className="flex-1">
                    <h4 className="font-bold text-tan">{path.title}</h4>
                    <p className="text-sm text-tan-dark">{path.description}</p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs bg-tan text-navy px-2 py-1 rounded">
                        {path.rank}
                      </span>
                      <span className="text-xs text-tan-dark">
                        +{path.points} BroScore
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {selectedPath && (
        <Button 
          onClick={() => handlePathSelect(selectedPath)}
          className="w-full bg-tan text-navy hover:bg-tan-dark"
        >
          Continue with {paths.find(p => p.id === selectedPath)?.title}
        </Button>
      )}
    </div>
  );
};

export default InitiationPath;
